<!-- Ported from the Polaris kit: src/components/ui/table/TableEmpty.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { cn } from '../../lib/utils';
import TableCell from './TableCell.vue';
import TableRow from './TableRow.vue';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  colspan: { type: Number, required: false, default: 1 },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
  <TableRow>
    <TableCell
      :class="
        cn(
          'p-4 whitespace-nowrap align-middle type-polaris-body text-polaris-foreground',
          props.class
        )
      "
      v-bind="delegatedProps"
    >
      <div class="flex items-center justify-center py-10">
        <slot />
      </div>
    </TableCell>
  </TableRow>
</template>
